"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertEmptyView = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const AdaptableContext_1 = require("../AdaptableContext");
const AlertEmptyView = (props) => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const accessLevel = adaptable.api.internalApi
        .getEntitlementService()
        .getEntitlementAccessLevelForModule(props.module.moduleInfo.ModuleName);
    const text = accessLevel == 'ReadOnly'
        ? 'You have no Alert Definitions.'
        : "Click 'New' to create a new Alert Definition. The Definition will include the Rule which triggers the Alert, and the behaviour of the Alert.";
    return React.createElement(React.Fragment, null, text);
};
exports.AlertEmptyView = AlertEmptyView;
